import styled from "styled-components";
import { FiltersSection } from "ui/blocks/filtersSection/FiltersSection";
import { defaultThemeColors, fonts, mediaSizes } from "ui/theme";
import { FiltersModal } from "ui/base/modal/FiltersModal";
import { useState } from "react";
import SearchBar from "./SearchBar";

export const HeaderFilter = ({ primary }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Navigation primary={primary} open={open}>
                <div className="scale-down-filters" onClick={() => setOpen(true)}>
                    <SearchBar />
                </div>

            </Navigation>
            <FiltersModal show={open} handleClose={() => setOpen(false)}>
                <FiltersSection
                    hasSeparator={false}
                    onSearch={() => setOpen(false)}
                />
            </FiltersModal>
        </>
    );
};

const Navigation = styled.div`
    display: none;
    gap: 1rem;
    font-size: ${fonts.sizes.small};
    color: ${({ primary }) =>
        primary ? defaultThemeColors.white : defaultThemeColors.txt};
    width: 100%;

    @media (width >= ${mediaSizes.md}) {
        display: flex;
        justify-content: center;
    }

    & .scale-down-filters {
        opacity: ${({ open }) => (open ? 0 : 1)};
        visibility: ${({ open }) => (open ? "hidden" : "visible")};
        transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
        cursor: pointer;
        width: 100%;

        & * {
            pointer-events: none;
        }


        @media (width >= ${mediaSizes.md}) {
            display: flex;
            justify-content: center;
        }
        @media (width >= ${mediaSizes.lg}) {
            scale: 0.6;
            margin-left: calc(-2%);
            margin-right: calc(-10%);
        }
    }
`;

